"use strict";
/**
*  Author:XCL
   Time:2015-12-05  
*/
angular.module('util.checkbox', []).directive("trsCheckbox", ["$timeout", function($timeout) {
    return {
        restrict: "EA",
        replace: false,
        scope: {
            ischecked: "=",
            callback: "&",
            label: "@",
            disabled: "="
        },
        template: ['<input  class="regular-checkbox" type="checkbox" ng-checked="ischecked">',
            '<label ng-class="{\'disabled\':disabled}" ng-click="toggleStatus($event)"></label>',
            '<span ng-class="{\'disabled\':disabled}" class="tip" ng-click="toggleStatus($event)" bindonce bo-bind="label"></span>'
        ].join(""),
        link: function(scope, elem, attrs, controller) {
            scope.toggleStatus = function($event) {
                $event.stopPropagation();
                if (scope.disabled) return;
                $timeout(function() {
                    scope.callback();
                });
            };

            scope.$watch('ischecked', function(checked) {
                var $tr = elem.closest('tr');
                var $cbx = $tr.find('.regular-checkbox');
                if (!$cbx) {
                    return;
                }
                $tr[checked ? 'addClass' : 'removeClass']('selected-row');
            });
        }
    };
}]).directive("trsCheckboxOnce", ["$timeout", function($timeout) {
    return {
        restrict: "EA",
        replace: false,
        scope: {
            ischecked: "=",
            callback: "&",
            label: "@"
        },
        template: ['<input  class="regular-checkbox" type="checkbox" ng-checked="ischecked">',
            '<label ng-click="toggleStatus($event)"></label>',
            '<span bindonce bo-bind="label"></span>'
        ].join(''),
        link: function(scope, elem, attrs, controller) {
            scope.toggleStatus = function($event) {
                $event.stopPropagation();
                $timeout(function() {
                    scope.callback();
                });
            };
            scope.$watch('ischecked', function(checked) {
                var $tr = elem.closest('tr');
                var $cbx = $tr.find('.regular-checkbox');
                if (!$cbx) {
                    return;
                }
                $tr[checked ? 'addClass' : 'removeClass']('selected-row');
            });
            // watch();
        }
    };
}]);